import { $, $$, $$$, breakpoint } from 'dlr-utils/helpers';

/**
 * IMPORTANT: THIS WILL ALWAYS BE AN ARRAY
 * Always make it possible for multiple instances
 * of your module to work on the pages.
 */
const SELECTOR = '.dlr-market-highlights';
const INSTANCES = $$(SELECTOR);

/* If you want to target just one, just uncomment the line below */
// const ELEMENT = SELECTOR[0];

/**
 * 1. Mounting
 *
 * Put module-specific variables and functions here.
 * Actions in this scope will fire as soon as the module
 * is mounted (not yet attached to the page)
 *  e.g. setting of initial states (see below), data fetching, etc
 *
 * The default export functions are the only
 * ones used by the dynamic module importer (main.js).
 * upon page load. main.js will only fire these if
 * at least one element with the class ".dlr-market-highlights" exists
 */
const IS_ACTIVE = '--is-active';
const IS_PREVIOUS_ACTIVE = '--is-previous-active';
const IS_SCROLL_END = '--is-scroll-end';

export default {
  /**
   * 2. REGISTRATION
   *
   * Use `init` for actions that should fire as soon as
   * the module file has been made available to the page
   *  - e.g. data transformations, MessageBus Subscriptions
   */
  init(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;

    /* Listening to a custom event */
    MessageBus.subscribe('GET_MARKET_DETAILS_HEIGHT_HANDLER', ({ module }) => {
      const activeCard = $(`article.${IS_ACTIVE}`, module);
      const previousCard = $(`article.${IS_PREVIOUS_ACTIVE}`, module);
      const delay = previousCard?.offsetHeight > activeCard?.offsetHeight ? 300 : 0; // ms

      // card height transition
      setTimeout(() => module.style.setProperty('--card-height', `${activeCard.offsetHeight + 1}px`), delay);
    });

    MessageBus.subscribe('MARKET_ANCHOR_HANDLER', ({ module, event }) => {
      event.preventDefault();

      const { target } = event;
      const targetCard = target.parentNode.nextElementSibling;
      const activeItems = $$(`.${IS_ACTIVE}`, module);

      // remove previous active items and set new active
      activeItems.forEach(item => {
        item.classList.remove(IS_ACTIVE);
        item.classList.add(IS_PREVIOUS_ACTIVE);
        setTimeout(() => item.classList.remove(IS_PREVIOUS_ACTIVE), 700);
      });
      target.classList.add(IS_ACTIVE);
      targetCard.classList.add(IS_ACTIVE);

      MessageBus.publish('GET_MARKET_DETAILS_HEIGHT_HANDLER', { module: module });
    });

    MessageBus.subscribe('MARKET_LISTS_VERTICAL_SCROLL_HANDLER', ({ module }) => {
      const listsContainer = $(`${SELECTOR}__markets-lists`, module);

      const isScrollable = () => {
        const scrollWidth = (listsContainer.scrollWidth - 2);
        const { scrollLeft, offsetWidth } = listsContainer;
        const isScrollEnd = scrollWidth - scrollLeft <= offsetWidth;

        isScrollEnd ? 
          module.classList.add(IS_SCROLL_END) : 
          module.classList.remove(IS_SCROLL_END);
      }


      setTimeout(isScrollable, 100);
      onResize(resizeEvent => isScrollable());
      listsContainer.addEventListener('scroll', event => isScrollable());
    });
  },

  /**
   * 3. RENDERING
   *
   * Use `finalize` for actions that should run
   * as soon as the module is rendered to the page
   * - e.g. Event Listeners, DOM Manipulations,
   *        MessageBus Publishers, etc
   */
  finalize(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;
    let lastBreakpoint = null;

    INSTANCES.forEach(instance => {
      MessageBus.publish('MARKET_LISTS_VERTICAL_SCROLL_HANDLER', { module: instance });
      MessageBus.publish('GET_MARKET_DETAILS_HEIGHT_HANDLER', { module: instance });
      onResize(resizeEvent => {
        MessageBus.publish('GET_MARKET_DETAILS_HEIGHT_HANDLER', { module: instance });
      });
    });

    $$$(`${SELECTOR}__markets-anchor`, SELECTOR).on('click', event => {
      const module = event.target.closest(SELECTOR);

      MessageBus.publish('MARKET_ANCHOR_HANDLER', { module: module, event: event });
    });
  },
};



// WEBPACK FOOTER //
// ../views/modules/market-highlights/market-highlights.js